const actions = {
  ROLES_TABLE_READ_BEGIN: 'ROLES_TABLE_READ_BEGIN',
  ROLES_TABLE_READ_SUCCESS: 'ROLES_TABLE_READ_SUCCESS',
  ROLES_TABLE_READ_ERR: 'ROLES_TABLE_READ_ERR',

  rolesTableReadBegin: () => {
    return {
      type: actions.ROLES_TABLE_READ_BEGIN,
    };
  },

  rolesTableReadSuccess: (data) => {
    return {
      type: actions.ROLES_TABLE_READ_SUCCESS,
      data,
    };
  },

  rolesTableReadErr: (err) => {
    return {
      type: actions.ROLES_TABLE_READ_ERR,
      err,
    };
  },
};

export default actions;
